module.exports = __webpack_public_path__ + "img/FR14806.5f806e82.svg";